import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  ICommAutomobileGarageApplicationData,
  defaultCommAutomobileGarageApplicationState,
} from "./commAutoGarageApplication.types";
import { uploadFile } from "../../../helpers";

export const FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_PROGRESS =
  "FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_PROGRESS";
export const FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_SUCCESSS =
  "FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_SUCCESSS";
export const FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_FAILED =
  "FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_FAILED";

export const fetchCommAutomobileGarageApplicationProgress = () =>
  action(FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_PROGRESS);
export const fetchCommAutomobileGarageApplicationSuccess = (
  data: ICommAutomobileGarageApplicationData
) => action(FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_SUCCESSS, { data });
export const fetchCommAutomobileGarageApplicationFailed = () =>
  action(FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_FAILED);

export const fetchCommAutomobileGarageApplicationAsync =
  (
    customerPolicyId: number,
    garageNumber: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutomobileGarageApplicationProgress());
      const res = await api.get(
        `/policy/get-commauto-garage-application?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${garageNumber}`
      );
      const data: ICommAutomobileGarageApplicationData[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchCommAutomobileGarageApplicationSuccess(data[0]));
      } else {
        dispatch(
          fetchCommAutomobileGarageApplicationSuccess(
            defaultCommAutomobileGarageApplicationState["data"]
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchCommAutomobileGarageApplicationFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addCommAutomobileGarageApplication =
  (
    data: ICommAutomobileGarageApplicationData,
    customerID: number,
    signatureFile: any | null,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
        customer_id: customerID,
        policy_type: "COMM_AUTOMOBILE",
        customer_policy_id: data.customer_policy_id,
        page_name: "Comm-Auto Garage Application",
      };

      const path = await uploadFile(
        signatureFile,
        "POLICY",
        data.signature_of_broker || "",
        asPayload
      );
      await api.post("/policy/edit-commauto-garage-application", {
        ...data,
        signature_of_broker: path,
      });
      onCallback(true);
      dispatch(
        showMessage({
          type: "success",
          message: "Garage Application  saved successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchCommAutomobileGarageApplicationSuccess(data));
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_COMM_AUTOMOBILE_GARAGE_APPLICATION_STATE =
  "CLEAR_COMM_AUTOMOBILE_GARAGE_APPLICATION_STATE";

export const clearCommAutomobileGarageApplicationState = () =>
  action(CLEAR_COMM_AUTOMOBILE_GARAGE_APPLICATION_STATE);

export const FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_PROGRESS =
  "FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_PROGRESS";
export const FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_SUCCESS =
  "FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_SUCCESS";
export const FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_FAILED =
  "FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_FAILED";

export const fetchCommAutomobileGarageApplicationListProgress = () =>
  action(FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_PROGRESS);

export const fetchCommAutomobileGarageApplicationListSuccess = (
  data: ICommAutomobileGarageApplicationData[]
) =>
  action(FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_SUCCESS, {
    data,
  });
export const fetchCommAutomobileGarageApplicationListFailed = () =>
  action(FETCH_COMM_AUTOMOBILE_GARAGE_APPLICATION_LIST_FAILED);

export const fetchCommAutomobileGarageApplicationListAsync =
  (customerPolicyId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutomobileGarageApplicationListProgress());
      const res = await api.get(
        `/policy/get-commauto-garage-application?customer_policy_id=${customerPolicyId}`
      );
      const data: ICommAutomobileGarageApplicationData[] = res.data.data;
      dispatch(fetchCommAutomobileGarageApplicationListSuccess(data));
    } catch (err: any) {
      dispatch(fetchCommAutomobileGarageApplicationListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_COMM_AUTOMOBILE_APPLICATION_STATE =
  "CLEAR_COMM_AUTOMOBILE_APPLICATION_STATE";

export const clearCommAutomobileApplicationState = () =>
  action(CLEAR_COMM_AUTOMOBILE_APPLICATION_STATE);

// /policy/edit-commauto-garage-application
// /policy/get-commauto-garage-application
